import { render } from "./ModalMitre.vue?vue&type=template&id=bb9e66d2&scoped=true"
import script from "./ModalMitre.vue?vue&type=script&lang=js"
export * from "./ModalMitre.vue?vue&type=script&lang=js"

import "./ModalMitre.vue?vue&type=style&index=0&id=bb9e66d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9e66d2"]])

export default __exports__